import { jsx } from "react/jsx-runtime";
import { useRef, useState, useCallback, useMemo, useEffect, createContext, useContext } from "react";
const FORM_STATUS = {
  BUSY: "BUSY",
  READY: "READY"
};
const FormStatusContext = createContext(
  void 0
);
const FormStatusProvider = ({
  children,
  onStatusChange
}) => {
  const previousFormStatus = useRef(FORM_STATUS.READY);
  const [fieldStatusByTarget, setFieldStatusByTarget] = useState({});
  const setFormStatus = useCallback((target, status) => {
    setFieldStatusByTarget((previous) => ({ ...previous, [target]: status }));
  }, []);
  const currentFormStatus = useMemo(() => {
    const isFormBusy = Object.values(fieldStatusByTarget).some(
      (status) => status === FORM_STATUS.BUSY
    );
    return isFormBusy ? FORM_STATUS.BUSY : FORM_STATUS.READY;
  }, [fieldStatusByTarget]);
  useEffect(() => {
    if (previousFormStatus.current !== currentFormStatus) {
      previousFormStatus.current = currentFormStatus;
      onStatusChange?.(currentFormStatus);
    }
  }, [currentFormStatus, onStatusChange]);
  const contextValue = useMemo(() => {
    return {
      formStatus: currentFormStatus,
      setFormStatus
    };
  }, [currentFormStatus, setFormStatus]);
  return /* @__PURE__ */ jsx(FormStatusContext.Provider, { value: contextValue, children });
};
function useFormStatus() {
  const context = useContext(FormStatusContext);
  if (context === void 0) {
    throw new Error("useFormStatus must be used within a Form Status provider");
  }
  return context;
}
export {
  FORM_STATUS,
  FormStatusProvider,
  useFormStatus
};
//# sourceMappingURL=form-status-provider.js.map
